import React from 'react';
import { useTranslation } from 'react-i18next';
import css from './DishReplacementsModal.module.css';

const DishReplacementsModal = ({ setIsShowDishReplacementsModal, dishReplacements }) => {
  const { t } = useTranslation();

  const closeModal = () => {
    setIsShowDishReplacementsModal(false);
  };

  return (
    <div className={css.overlay}>
      <div className={css.modal}>
        <div className={css.header}>
          <div className={css.title}>{t('dish-replacements')}</div>
          <div className={css.closeButton} onClick={closeModal}>&times;</div>
        </div>

        <div className={css.container}>
          {dishReplacements && dishReplacements.length > 0 ? (
            <div className={css.tableContainer}>
              <div className={css.tableHeader}>
                <div className={css.originalPrice}>{t('original-price')}</div>
                <div className={css.newPrice}>{t('new-price')}</div>
                <div className={css.replacementCharge}>{t('replacement-charge')}</div>
              </div>
              
              {dishReplacements.map((replacement, index) => (
                <div key={replacement.id || index} className={css.tableRow}>
                  <div className={css.originalPrice}>{replacement.originalPrice}</div>
                  <div className={css.newPrice}>{replacement.newPrice}</div>
                  <div className={css.replacementCharge}>{replacement.replacementCharge}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className={css.empty}>{t('no-data')}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export { DishReplacementsModal };
